/**
 * ----------------------------------------------------------------------------
 * DeviceAccess Container Component
 * ----------------------------------------------------------------------------
 * Summary:
 * This component acts as a parent/container component for DeviceAccessForm.
 * It is responsible for:
 * - Fetching user data from redux store
 * - Managing initial form state
 * - Handling form submission logic
 * - Passing required props and callbacks to the child form component
 * - Managing modal close/reset operations
 *
 * The actual UI rendering and form controls are handled inside
 * the DeviceAccessForm child component.
 *
 * @author Chandan Singh
 * @created 2026-05-07
 * ----------------------------------------------------------------------------
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeviceAccessForm from './components/DeviceAccessForm';
import * as actions from '../../core/actions/actions'
import IState from '../../core/models/IState';
import { toast } from 'react-toastify';
import { formatMessage } from '../../translations/connectedIntlProvider'

const DeviceAccess = (props: any) => {
    const dispatch = useDispatch();
    const stateAllUsers = (state: IState) => state.user.userList.users;
    const stateAllDevices = (state: IState) => state.sensor.allDevices;
    const updateDeviceAccessState = (state: IState) => state.sensor.updateDeviceAccess
    const allUsersData: any = useSelector(stateAllUsers);
    const allDeviceData: any = useSelector(stateAllDevices);
    const updateDeviceAccess: any = useSelector(updateDeviceAccessState)
    const [shouldClose, setShouldClose] = useState(false)

    useEffect(() => {
        const showAll = localStorage.getItem('userType') !== 'General';
        dispatch(actions.getAllUser(1, 10000, showAll));
        dispatch(actions.allDevicesWithoutPagination());
    }, []);

    useEffect(() => {
        if (updateDeviceAccess.success) {
            toast.success(formatMessage("Device_Access_Update_Successfully"));
            dispatch(actions.resetUpdateDeviceAccessState())
            if (shouldClose) {
                setShouldClose(false);
                onModalClosed();
            }
        }
    }, [updateDeviceAccess.success]);

    useEffect(()=>{
        if(updateDeviceAccess.error){
            toast.error(formatMessage(updateDeviceAccess.error))
            dispatch(actions.resetUpdateDeviceAccessState());
        }
    },[updateDeviceAccess.error])

    const onSubmitForm = (user: string, devices: any, primaryDevice: any, flag: boolean) => {
        if (flag) setShouldClose(true)
        // if(devices?.length>0)
        dispatch(actions.updateDeviceAccess({ user, devices }))
    }

    const onModalClosed = () => {
        dispatch(actions.resetUserDevicesState());
        props.modalClosed();
    }

    return (
        <React.Fragment>
            <DeviceAccessForm
                allDevices={allDeviceData.devices?.map((d: any) => ({
                    ID: d.ID,
                    ICCID: d.ICCID,
                    UserId: d.UserID,
                }))}
                submitHandler={onSubmitForm}
                onModalClosed={onModalClosed}
                isLoading={props.isLoading}
                allUsersData={allUsersData.Users}
            />
        </React.Fragment>
    );
};

export default DeviceAccess;